export default __webpack_public_path__ + "static/media/avatar-v.f815c407.png";